import { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../services/store';
import { removeError } from '../services/reducers/ui.slice';
import ErrorModal from '../components/UI/ErrorModal/ErrorModal';

interface ErrorProvider {
  children: React.ReactNode;
}
export const ErrorProvider: FC<ErrorProvider> = ({ children }) => {
  const dispatch = useAppDispatch();
  const errors = useAppSelector((store) => store.ui.errors);

  const handleClear = (id: number) => {
    dispatch(removeError(id));
  };

  return (
    <>
      {errors?.map(({ id, message }) => (
        <ErrorModal key={id + message} onClear={() => handleClear(id)} error={message} header={''}></ErrorModal>
      ))}
      {children}
    </>
  );
};
